import { makeStyles } from "@material-ui/core/styles";

const PARTNER_MENU_FONT_ID = "partner-menu-fonts";

if (typeof document !== "undefined" && !document.getElementById(PARTNER_MENU_FONT_ID)) {
  const link = document.createElement("link");
  link.id = PARTNER_MENU_FONT_ID;
  link.rel = "stylesheet";
  link.href =
    "https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Mono:wght@400;500&family=DM+Sans:wght@300;400;500;600&display=swap";
  document.head.appendChild(link);
}

const useTreeItemStyles = makeStyles(() => ({
  sidebarRoot: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    backgroundColor: "#ffffff",
    color: "#64748b",
    fontFamily: "'DM Sans', sans-serif",
    paddingTop: 6,
  },
  section: {
    width: "100%",
  },
  footerSection: {
    marginTop: "auto",
    paddingTop: 8,
    paddingBottom: 8,
    borderTop: "1px solid #e2e8f0",
  },
  sectionTitle: {
    padding: "12px 16px 4px",
    fontSize: 10,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: 1.5,
    fontWeight: 600,
    fontFamily: "'DM Sans', sans-serif",
  },
  treeView: {
    "& .MuiTreeItem-iconContainer": {
      display: "none",
    },
    "& .MuiTreeItem-group": {
      marginLeft: 0,
      paddingLeft: 0,
    },
  },
  root: {
    color: "#64748b",
    fontFamily: "'DM Sans', sans-serif",
  },
  content: {
    margin: "4px 10px",
    padding: "8px 12px",
    minHeight: 36,
    borderLeft: "none",
    borderRadius: 10,
    "&:hover": {
      backgroundColor: "#eef4ff",
      color: "#1d4ed8",
    },
    "&.Mui-focused, &.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: "transparent",
      color: "#1d4ed8",
    },
    "& .MuiTreeItem-label": {
      width: "100%",
      backgroundColor: "transparent",
    },
  },
  contentLabel: {
    marginLeft: "auto",
    minWidth: 24,
    padding: "1px 6px",
    textAlign: "center",
    borderRadius: 4,
    fontFamily: "'DM Mono', monospace",
    fontSize: 10,
    lineHeight: "12px",
    color: "#1d4ed8",
    background: "rgba(37, 99, 235, 0.12)",
  },
  group: {
    marginLeft: 0,
    "& $content": {
      paddingLeft: 12,
    },
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: "inherit",
    color: "inherit",
    backgroundColor: "transparent",
  },
  labelRoot: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    color: "inherit",
    textDecoration: "none",
    backgroundColor: "transparent",
    "&:focus, &:active": {
      backgroundColor: "transparent",
    },
  },
  labelIcon: {
    width: 17,
    marginRight: 8,
    fontSize: 13,
    textAlign: "center",
    flexShrink: 0,
    color: "inherit",
    backgroundColor: "transparent",
  },
  labelText: {
    flexGrow: 1,
    fontSize: 12,
    fontWeight: 500,
    color: "inherit",
    fontFamily: "'DM Sans', sans-serif",
    backgroundColor: "transparent",
  },
  labelTextBold: {
    flexGrow: 1,
    fontSize: 12,
    fontWeight: 600,
    color: "inherit",
    fontFamily: "'DM Sans', sans-serif",
    backgroundColor: "transparent",
  },
  activeMenu: {
    "& $content": {
      backgroundColor: "#e8f1ff",
      color: "#1d4ed8",
      boxShadow: "inset 0 0 0 1px rgba(37, 99, 235, 0.12)",
    },
    "& $labelText, & $labelTextBold, & $labelIcon": {
      color: "#1d4ed8",
    },
  },
  badgeBlue: {
    color: "#4f8ef7",
    background: "rgba(79,142,247,.18)",
  },
  badgeRed: {
    color: "#f87171",
    background: "rgba(248,113,113,.15)",
  },
  badgeYellow: {
    color: "#fbbf24",
    background: "rgba(251,191,36,.15)",
  },
  badgeGreen: {
    color: "#34d399",
    background: "rgba(52,211,153,.15)",
  },
}));

export default useTreeItemStyles;
